// Libraries
import React, {SFC} from 'react'

const LogoApache: SFC = () => {
  return (
    <svg width="100%" height="100%" viewBox="0 0 49.92 100">
      <defs>
        <linearGradient
          id="apache_c"
          x1={-1886.65}
          y1={4996.93}
          x2={-1872.53}
          y2={4980.42}
          gradientTransform="scale(1 -1) rotate(65.2 2995.766 3977.41)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#f69923" />
          <stop offset={0.31} stopColor="#f79a23" />
          <stop offset={0.84} stopColor="#e97826" />
        </linearGradient>
        <linearGradient
          id="apache_a"
          x1={-1991.78}
          y1={4989.78}
          x2={-1891.01}
          y2={4989.78}
          gradientTransform="scale(1 -1) rotate(65.2 2995.766 3977.41)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.32} stopColor="#9e2064" />
          <stop offset={0.63} stopColor="#c92037" />
          <stop offset={0.75} stopColor="#cd2335" />
          <stop offset={1} stopColor="#e97826" />
        </linearGradient>
        <linearGradient
          id="apache_d"
          x1={-1991.19}
          y1={4998.76}
          x2={-1890.42}
          y2={4998.76}
          xlinkHref="#apache_a"
        />
        <linearGradient
          id="apache_e"
          x1={-1985.53}
          y1={4989.27}
          x2={-1884.76}
          y2={4989.27}
          xlinkHref="#apache_a"
        />
        <linearGradient
          id="apache_f"
          x1={-1985.53}
          y1={4999.7}
          x2={-1884.76}
          y2={4999.7}
          xlinkHref="#apache_a"
        />
        <linearGradient
          id="apache_b"
          x1={-1979.02}
          y1={4988.65}
          x2={-1918.97}
          y2={4988.65}
          gradientTransform="scale(1 -1) rotate(65.2 2995.766 3977.41)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#282662" />
          <stop offset={0.1} stopColor="#662e8d" />
          <stop offset={0.79} stopColor="#9f2064" />
          <stop offset={0.95} stopColor="#cd2032" />
        </linearGradient>
        <linearGradient
          id="apache_g"
          x1={-1978.18}
          y1={4998.33}
          x2={-1925.22}
          y2={4998.33}
          xlinkHref="#apache_b"
        />
      </defs>
      <title>logo_apache</title>
      <path
        d="M42.56.48C41 1.4 38.39 4 35.28 7.82l2.85 5.39a71.05 71.05 0 0 1 6.1-7.65 3.45 3.45 0 0 1 .25-.26l-.25.26a64.18 64.18 0 0 0-5.72 7.76A108.36 108.36 0 0 0 49.62 12c1.09-6.18-1.08-9-1.08-9S45.79-1.43 42.56.48z"
        fill="url(#apache_c)"
      />
      <path
        d="M38.51 13.32q-1.26 1.93-2.75 4.42l-.15.26c-.85 1.43-1.76 3-2.71 4.74q-1.23 2.26-2.57 4.81-1.17 2.23-2.4 4.77l9.45-1a11.45 11.45 0 0 0 5.17-4.07c.32-.45.64-.93 1-1.43 1-1.51 1.92-3.18 2.77-4.84s1.54-3.19 2.1-4.62a22.75 22.75 0 0 0 .83-2.5c.17-.65.31-1.28.41-1.87a105.64 105.64 0 0 1-11.15 1.33z"
        fill="url(#apache_a)"
      />
      <path
        d="M29.71 27.15c.87-1.62 1.75-3.21 2.64-4.75s1.85-3.16 2.8-4.66l.16-.27q1.41-2.22 2.83-4.26l-2.86-5.39c-.22.26-.43.53-.65.8-.83 1-1.68 2.13-2.56 3.3-1 1.32-2 2.74-3 4.21s-1.92 2.8-2.89 4.28c-.82 1.26-1.65 2.56-2.47 3.9l-.09.14 3.68 7.35c.79-1.57 1.6-3.12 2.41-4.65z"
        fill="url(#apache_d)"
      />
      <path
        d="M27.87 32.42c-.1.22-.21.44-.32.66-.32.67-.65 1.34-1 2s-.71 1.51-1.08 2.3c-.18.39-.37.79-.55 1.2-.56 1.2-1.12 2.45-1.69 3.74-.71 1.59-1.42 3.23-2.15 5s-1.38 3.3-2.08 5.05-1.36 3.37-2 5.13c-.62 1.57-1.24 3.18-1.87 4.85l-.09.24q-.95 2.47-1.89 5.08v.12l3-.33a1.35 1.35 0 0 0-.18 0c3.5-.46 8.28-3.17 11.37-6.46a27.81 27.81 0 0 0 3.91-5.44 45.77 45.77 0 0 0 2.52-5.24c.7-1.68 1.36-3.51 2-5.49a10.65 10.65 0 0 1-2.82 1l-.56.11-.57.09a13.11 13.11 0 0 0 7-6.83 11.73 11.73 0 0 1-4 1.76 6 6 0 0 1-.72.13h-.18a13.55 13.55 0 0 0 3-1.67c.18-.14.36-.28.53-.43a9.88 9.88 0 0 0 .74-.71c.15-.16.3-.32.44-.49a11.23 11.23 0 0 0 .94-1.29l.27-.44.32-.63a35.043 35.043 0 0 0 1.53-3.52l.13-.37c.11-.35.21-.67.29-.94s.18-.75.22-1a3.77 3.77 0 0 1-.39.26 14.18 14.18 0 0 1-4.15 1.42h-.07l-.42.07h.07l-9.44 1z"
        fill="url(#apache_e)"
      />
      <path
        d="M14.17 61.81q1-2.52 2-5.1t2-5q1-2.49 2.12-5c.74-1.69 1.49-3.39 2.25-5.07s1.52-3.32 2.3-5c.28-.59.57-1.18.85-1.76.49-1 1-2 1.49-3l.09-.16-3.72-7.35c-.06.1-.12.2-.19.3-.86 1.42-1.72 2.86-2.57 4.34s-1.7 3-2.52 4.56c-.69 1.3-1.37 2.61-2 3.94l-.39.8q-1.22 2.51-2.2 4.83c-.75 1.75-1.41 3.43-2 5q-.57 1.57-1 3c-.26.83-.5 1.66-.74 2.48q-.83 2.93-1.43 5.83l3.7 7.55c.5-1.32 1-2.66 1.52-4 .15-.43.27-.81.44-1.19z"
        fill="url(#apache_f)"
      />
      <path
        d="M12.77 68.54c-.49 1.36-1 2.73-1.48 4.14v.06l-.21.6-1.32 3.75c1.1.49 2 1.81 2.81 3.3a6 6 0 0 0-1.94-4.12c5.4.25 10.06-1.12 12.46-5.07a9.11 9.11 0 0 0 .59-1.12c-1.09 1.39-2.45 2-5 1.84 3.76-1.69 5.64-3.3 7.31-6 .39-.63.78-1.32 1.17-2.09a11.77 11.77 0 0 1-11.1 3.6l-3 .33c-.06.24-.2.53-.29.78z"
        fill="url(#apache_b)"
      />
      <path
        d="M8.43 59.84a55.52 55.52 0 0 0-1 7 2 2 0 0 0 0 .25 14.73 14.73 0 0 0-4.29-3.68c2.24 3.24 3.94 6.46 4.19 9.62a9.47 9.47 0 0 1-4.73-.81 9.38 9.38 0 0 0 4 2.45c-1.81.12-3.7 1.36-5.61 2.8 2.79-1.14 5-1.59 6.65-1.22C5.12 83.53 2.56 91.52 0 100a2.24 2.24 0 0 0 1.52-1.47C2 97 5 86.92 9.75 73.67c.14-.37.27-.75.41-1.13l.12-.32c.5-1.39 1-2.8 1.56-4.25.12-.33.24-.66.37-1l-3.73-7.39a2.38 2.38 0 0 0-.05.26z"
        fill="url(#apache_g)"
      />
    </svg>
  )
}

export default LogoApache
